import * as actionTypes from '../actions/actionTypes';

const initialState = {
    departmentEmployees: [],
    departmentName: '',
    loadingDepartmentEmployees: false,
    employeeDetails: null,
    loadingEmployeeDetails: false,
    serverNotFoundEntity: false
};

const loadDepartmentEmployees = (state) => {
    return {
        ...state,
        loadingDepartmentEmployees: true
    }
}

const setDepartmentName = ( state, action ) => {
    return {
        ...state,
        departmentName: action.departmentName
    }
};

const setDepartmentEmployees = ( state, action ) => {
    let tmp = [...action.employees]
    return {
        ...state,
        departmentEmployees: tmp,
        loadingDepartmentEmployees: false
    }
};

const loadEmployeeDetails = (state) => {
    return {
        ...state,
        loadingEmployeeDetails: true
    }
}

const setEmployeeDetails = ( state, action ) => {
    let tmp = {...action.employeeDetails}
    return {
        ...state,
        employeeDetails: tmp,
        loadingEmployeeDetails: false,
    }
};

const setServerNotFoundEntity = (state, action) => {
    return {
        ...state,
        serverNotFoundEntity: action.serverNotFoundEntity,
    }
}

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.LOAD_DEPARTMENT_EMPLOYEES: return loadDepartmentEmployees( state );
        case actionTypes.SET_DEPARTMENT_NAME: return setDepartmentName( state, action );
        case actionTypes.SET_DEPARTMENT_EMPLOYEES: return setDepartmentEmployees( state, action );
        case actionTypes.LOAD_EMPLOYEE_DETAILS: return loadEmployeeDetails( state );
        case actionTypes.SET_EMPLOYEE_DETAILS: return setEmployeeDetails( state, action );
        case actionTypes.SERVER_NOT_FOUND_ENTITY: return setServerNotFoundEntity(state, action);
        default: return state;
    }
};
export default reducer;